import React, { useState, useContext, useEffect } from "react";
import { CompactPicker } from "react-color";
import { ColorContext } from "../../contexts/ColorContext";
import InvertColor from "../scripts/InvertColor";

const InputColor = ({ actionType, label, color}) => {
  const [background, setBackground] = useState(color);
  const [displayColorPicker, setdisplayColorPicker] = useState(false);
  const { colors, dispatch } = useContext(ColorContext);

  const handleClick = () => {
    setdisplayColorPicker(!displayColorPicker);
  };
  const handleClose = () => {
    setdisplayColorPicker(false);
  };
  const handleChangeComplete = (color, event) => {
    setBackground(color.hex);
    dispatch({ type: actionType, color: color.hex});
  };
  useEffect(() => {
    if (colors.backgroundColor === colors.logoColor) {
      const logoColor = InvertColor(colors.logoColor, true);
      dispatch({ type: "UPDATE_LOGO_COLOR", color: logoColor });
    }
  },[colors]);

  const popover = {
    position: "absolute",
    zIndex: "2",
  };
  const cover = {
    position: "fixed",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px",
  };
  return (
    <div>
      <button className="input-color" onClick={handleClick}>
        {label} <i className="far fa-edit"></i>
      </button>
      {displayColorPicker ? (
        <div style={popover}>
          <div style={cover} onClick={handleClose} />
          <CompactPicker
            color={background}
            onChangeComplete={handleChangeComplete}
          />
        </div>
      ) : null}
    </div>
  );
};

export default InputColor;
